// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"ResetPasswordForm_resetPasswordForm__9w2r7","passwordContainer":"ResetPasswordForm_passwordContainer__5m11R","eyeIcon":"ResetPasswordForm_eyeIcon__m6RD8"};